const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  OAUTH: '/oauth',
};

export const paths = {
  // Auth
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
  },
  // OAuth (MCP server consent hand-off)
  oauth: {
    consent: `${ROOTS.OAUTH}/consent`,
  },
  // Dashboard
  dashboard: {
    root: ROOTS.DASHBOARD,
    videos: `${ROOTS.DASHBOARD}/videos`,
    images: `${ROOTS.DASHBOARD}/images`,
    audio: `${ROOTS.DASHBOARD}/audio`,
    team: `${ROOTS.DASHBOARD}/team`,
    myProfile: `${ROOTS.DASHBOARD}/profile`,
    security: `${ROOTS.DASHBOARD}/security`,
    review: `${ROOTS.DASHBOARD}/review`,
    auditLog: `${ROOTS.DASHBOARD}/activity-log`,
    appVersions: `${ROOTS.DASHBOARD}/app-versions`,
    cache: `${ROOTS.DASHBOARD}/cache`,
    assessments: `${ROOTS.DASHBOARD}/assessments`,
    notifications: {
      root: `${ROOTS.DASHBOARD}/notifications`,
      new: `${ROOTS.DASHBOARD}/notifications/new`,
      stats: (id) => `${ROOTS.DASHBOARD}/notifications/${id}/stats`,
      framework: {
        root: `${ROOTS.DASHBOARD}/notifications/framework`,
        ledger: `${ROOTS.DASHBOARD}/notifications/framework/ledger`,
        registry: `${ROOTS.DASHBOARD}/notifications/framework/registry`,
      },
    },
    content: {
      taxonomy: `${ROOTS.DASHBOARD}/content/taxonomy`,
      taxonomyQueue: `${ROOTS.DASHBOARD}/content/taxonomy/queue`,
      attributes: `${ROOTS.DASHBOARD}/content/attributes`,
    },
    session: {
      root: `${ROOTS.DASHBOARD}/session`,
      audio: {
        root: `${ROOTS.DASHBOARD}/session/audio`,
        queue: `${ROOTS.DASHBOARD}/session/audio/queue`,
        bulk: `${ROOTS.DASHBOARD}/session/audio/bulk`,
        new: `${ROOTS.DASHBOARD}/session/audio/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/session/audio/${id}/edit`,
      },
    },
    plan: {
      root: `${ROOTS.DASHBOARD}/plan`,
      activity: {
        root: `${ROOTS.DASHBOARD}/plan/activity`,
        queue: `${ROOTS.DASHBOARD}/plan/activity/queue`,
        groups: `${ROOTS.DASHBOARD}/coach/activity-groups`,
        new: `${ROOTS.DASHBOARD}/plan/activity/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/plan/activity/${id}/edit`,
      },
    },
    cv: {
      placementTester: `${ROOTS.DASHBOARD}/cv/placement-tester`,
    },
    devices: {
      root: `${ROOTS.DASHBOARD}/devices`,
      detail: (id) => `${ROOTS.DASHBOARD}/devices/${id}`,
      links: `${ROOTS.DASHBOARD}/devices/links`,
      import: `${ROOTS.DASHBOARD}/devices/import`,
    },
    customers: {
      root: `${ROOTS.DASHBOARD}/customers`,
      detail: (id) => `${ROOTS.DASHBOARD}/customers/${id}`,
      insights: (id) => `${ROOTS.DASHBOARD}/customers/${id}/insights`,
    },
    support: {
      console: `${ROOTS.DASHBOARD}/support/console`,
    },
    coach: {
      caseload: `${ROOTS.DASHBOARD}/coach/caseload`,
      directory: `${ROOTS.DASHBOARD}/coach/coaches`,
      profile: (memberId) => `${ROOTS.DASHBOARD}/coach/coaches/${memberId}`,
      quality: `${ROOTS.DASHBOARD}/coach/quality`,
      console: `${ROOTS.DASHBOARD}/coach/console`,
      assignment: `${ROOTS.DASHBOARD}/coach/assignment`,
    },
    ops: {
      now: `${ROOTS.DASHBOARD}/ops/now`,
      team: `${ROOTS.DASHBOARD}/ops/team`,
      issues: `${ROOTS.DASHBOARD}/ops/issues`,
      macros: `${ROOTS.DASHBOARD}/ops/macros`,
      conversations: `${ROOTS.DASHBOARD}/ops/conversations`,
    },
    insights: {
      root: `${ROOTS.DASHBOARD}/insights`,
      customer: (id) => `${ROOTS.DASHBOARD}/insights/${id}`,
    },
    biosignal: {
      root: `${ROOTS.DASHBOARD}/biosignal`,
      metrics: `${ROOTS.DASHBOARD}/biosignal/metrics`,
      observations: `${ROOTS.DASHBOARD}/biosignal/observations`,
    },
    subscriptions: {
      entitlements: `${ROOTS.DASHBOARD}/subscriptions/entitlements`,
      plans: `${ROOTS.DASHBOARD}/subscriptions/plans`,
    },
    production: {
      root: `${ROOTS.DASHBOARD}/production`,
      devices: `${ROOTS.DASHBOARD}/production/devices`,
      device: (ficr) => `${ROOTS.DASHBOARD}/production/devices/${ficr}`,
      chargers: `${ROOTS.DASHBOARD}/production/chargers`,
      charger: (ficr) => `${ROOTS.DASHBOARD}/production/chargers/${ficr}`,
      sets: `${ROOTS.DASHBOARD}/production/sets`,
      quality: `${ROOTS.DASHBOARD}/production/quality`,
      benches: `${ROOTS.DASHBOARD}/production/benches`,
      about: `${ROOTS.DASHBOARD}/production/about`,
    },
    firmware: {
      root: `${ROOTS.DASHBOARD}/firmware`,
      detail: (id) => `${ROOTS.DASHBOARD}/firmware/${id}`,
      queue: `${ROOTS.DASHBOARD}/firmware/queue`,
      logs: `${ROOTS.DASHBOARD}/firmware/logs`,
      rollbacks: `${ROOTS.DASHBOARD}/firmware/rollbacks`,
      rollbackDetail: (id) => `${ROOTS.DASHBOARD}/firmware/rollbacks/${id}`,
    },
  },
};
